import { wrapUrlSafe as wrapUrlSafeMonorepo, LanguageRegionCode, getLocale } from '@alltrails/shared/utils/languageSupport';

// Certain cases that match the above do not support translated components
const noMatchRegex = /\/(print|photos|edit)($|\?.*)/;

const localizeUrlComponents = (urlWithLanguagePrefix: string, languageRegionCode: LanguageRegionCode) => {
  const localizedPaths = global.__AT_DATA__?.localizedPaths;
  if (languageRegionCode === LanguageRegionCode.English || !localizedPaths) {
    return urlWithLanguagePrefix;
  }

  // Pattern distinguishes between /trail/new and /trail/new-zealand/...
  const localePathPrefix = getLocale(languageRegionCode);
  const matchRegex = new RegExp(`^\\/${localePathPrefix}\\/(trail\\/new|trail|parks)(\$|\\/.*|\\?.*)`);
  const match = urlWithLanguagePrefix.match(matchRegex);
  if (match && localizedPaths[match[1]] && !urlWithLanguagePrefix.match(noMatchRegex)) {
    return `/${localePathPrefix}/${localizedPaths[match[1]]}${match[2]}`;
  }

  return urlWithLanguagePrefix;
};

function wrapUrlSafe(url: string, languageRegionCode: LanguageRegionCode) {
  // No action if URL is already language-adjusted (wrapUrlSafe is sometimes called twice)
  if (url && languageRegionCode !== LanguageRegionCode.English) {
    const matchRegex = new RegExp(`^\\/${getLocale(languageRegionCode)}\\/(.*)`);
    if (url.match(matchRegex)) {
      return url;
    }
  }
  return localizeUrlComponents(wrapUrlSafeMonorepo(url, languageRegionCode), languageRegionCode);
}

const LanguageSupportUtil = {
  // deprecated
  // Do not use LanguageSupportUtil.wrapUrlSafe. Import wrapUrlSafe from the module exports below.
  wrapUrlSafe,
  findRecordFieldWithLocale(record: any, field: string, locale = 'en-US') {
    let translatedField = `${field}_${locale}`;
    if (translatedField in record) {
      return record[translatedField];
    }

    // TODO TOOLS-802 Fail-back to using the _xx key if the _xx-YY is absent
    // Can be removed once Algolia is fully populated
    translatedField = `${field}_${locale.substring(0, 2)}`;
    if (translatedField in record) {
      return record[translatedField];
    }

    if (field in record) {
      return record[field];
    }

    return '';
  }
};

export default LanguageSupportUtil;
export { LanguageSupportUtil, wrapUrlSafe };

if (process.env.NODE_ENV === 'test') {
  exports.localizeUrlComponents = localizeUrlComponents;
}
